import type { GridColumnVisibilityModel } from '@/ui/primitives';
import type { SuiteExecutionStatus } from '@flowqa/shared';

export type CloneSortDirection = 'asc' | 'desc';
export type CloneSortKey = 'name' | 'latestExecutionTimestamp';

export const cloneDefaultSortKey: CloneSortKey = 'latestExecutionTimestamp';
export const cloneDefaultSortDirection: CloneSortDirection = 'desc';

export const cloneSortOptions: Array<{ key: CloneSortKey; label: string }> = [
  { key: 'name', label: 'Suite Name' },
  { key: 'latestExecutionTimestamp', label: 'Latest' },
];

export const cloneSortFieldMap: Record<CloneSortKey, string> = {
  name: 'name',
  latestExecutionTimestamp: 'latestExecutionTimestamp',
};

export const cloneColumnOptions: Array<{ field: string; label: string; mandatory?: boolean }> = [
  { field: 'name', label: 'Suite', mandatory: true },
  { field: 'latestExecutionStatus', label: 'Latest Status' },
  { field: 'testLatestExecutionPassed', label: 'Latest Tests' },
  { field: 'executionStatusCounts', label: 'Executions' },
  { field: 'metricsSummary', label: 'Metrics' },
  { field: 'actions', label: 'Actions' },
];

export const cloneStatusOptions: Array<{ value: SuiteExecutionStatus; label: string }> = [
  { value: 'passed', label: 'Passed' },
  { value: 'failed', label: 'Failed' },
  { value: 'errored', label: 'Errored' },
  { value: 'skipped', label: 'Skipped' },
];

export const cloneDefaultColumnVisibilityModel: GridColumnVisibilityModel = {
  name: true,
  latestExecutionStatus: true,
  testLatestExecutionPassed: true,
  executionStatusCounts: true,
  metricsSummary: true,
  latestExecutionTimestamp: false,
  actions: true,
};
